import { useSyncExternalStore } from "react";
import { addDays } from "date-fns";
import { parseDateOnlyAsUTC, toUTCDateOnly } from "@common/helpers/date";

const listeners = new Set<() => void>();
let todayDateOnly = toUTCDateOnly(new Date());
let nextMidnightTimeout: ReturnType<typeof setTimeout> | undefined;

function refreshTodayDateOnly(): void {
    const currentDateOnly = toUTCDateOnly(new Date());
    if (currentDateOnly === todayDateOnly) {
        return;
    }
    todayDateOnly = currentDateOnly;
    listeners.forEach((listener) => listener());
}

function scheduleNextMidnightRefresh(): void {
    const nextMidnight = addDays(parseDateOnlyAsUTC(todayDateOnly), 1);
    nextMidnightTimeout = setTimeout(
        () => {
            refreshTodayDateOnly();
            scheduleNextMidnightRefresh();
        },
        Math.max(nextMidnight.getTime() - Date.now(), 0),
    );
}

export function subscribeToUTCDayChange(listener: () => void): () => void {
    if (listeners.size === 0) {
        todayDateOnly = toUTCDateOnly(new Date());
        scheduleNextMidnightRefresh();
    }
    listeners.add(listener);
    return () => {
        listeners.delete(listener);
        if (listeners.size === 0) {
            clearTimeout(nextMidnightTimeout);
        }
    };
}

const getTodayDateOnly = () => todayDateOnly;

export function useUTCTodayDateOnly(): string {
    return useSyncExternalStore(subscribeToUTCDayChange, getTodayDateOnly);
}
